module.exports = __webpack_public_path__ + "img/RedGrayBottom.e2cc28b8.jpg";